(function () {
  var DEBUG = true;
  var LOG_PREFIX = '[MSO]';

  function log() {
    if (!DEBUG) return;
    try { console.log.apply(console, [LOG_PREFIX].concat([].slice.call(arguments))); } catch (e) {}
  }
  function warn() {
    try { console.warn.apply(console, [LOG_PREFIX].concat([].slice.call(arguments))); } catch (e) {}
  }
  function err() {
    try { console.error.apply(console, [LOG_PREFIX].concat([].slice.call(arguments))); } catch (e) {}
  }

  function serializeFormArray(formEl) {
    var $ = window.jQuery || window.$;
    if ($ && typeof $(formEl).serializeArray === 'function') {
      return $(formEl).serializeArray();
    }
    var arr = [];
    try {
      var fd = new FormData(formEl);
      fd.forEach(function (value, key) {
        arr.push({ name: key, value: String(value) });
      });
    } catch (e) {}
    return arr;
  }

  function getThemeMoneyFormat() {
    return (
      (window.themeSettings && (window.themeSettings.money_format || window.themeSettings.moneyFormat)) ||
      (window.Theme && window.Theme.moneyFormat) ||
      (window.Theme && window.Theme.settings && (window.Theme.settings.moneyFormat || window.Theme.settings.money_format)) ||
      (window.Shopify && window.Shopify.money_format) ||
      null
    );
  }

  function getCartRedirectionSetting() {
    return !!(
      (window.themeSettings && (window.themeSettings.cart_redirection || window.themeSettings.cartRedirection)) ||
      (window.Theme && window.Theme.settings && window.Theme.settings.cartRedirection)
    );
  }

  function ensureEmpireFlyoutDOM() {
    var wrapper = document.querySelector('.atc-popup-wrapper');
    var template = document.querySelector('[data-templates] [data-atc-banner]');
    return { wrapper: wrapper, template: template, ok: !!(wrapper && template) };
  }

  function initOne(root) {
    if (!root || root.__msoInit) return;
    root.__msoInit = true;

    var sectionId = root.getAttribute('data-section-id') || '';
    log('Init sticky offer', sectionId, root);

    var qtyInput = root.querySelector('[data-mso-qty]');
    var radios = root.querySelectorAll('[data-mso-radio]');
    var options = root.querySelectorAll('[data-mso-option]');
    var form = root.querySelector('form');
    var atcButton = root.querySelector('.mso-atc');

    if (!form || !atcButton) {
      warn('Missing form or button in sticky offer', sectionId);
      return;
    }

    function setActive(selectedVal) {
      options.forEach(function (opt, idx) {
        var r = radios[idx];
        if (!r) return;
        opt.classList.toggle('is-active', r.value === selectedVal);
      });
      if (qtyInput) qtyInput.value = selectedVal;
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        setActive(radio.value);
      });
    });

    var checked = root.querySelector('[data-mso-radio]:checked');
    setActive(checked ? checked.value : '1');

    function applyBottomPadding() {
      if (window.matchMedia('(max-width: 749px)').matches) {
        document.body.style.paddingBottom = (root.offsetHeight + 8) + 'px';
      } else {
        document.body.style.paddingBottom = '';
      }
    }
    window.addEventListener('resize', applyBottomPadding);
    window.addEventListener('orientationchange', applyBottomPadding);
    applyBottomPadding();

    function setProcessing() {
      if (!atcButton || atcButton.classList.contains('processing')) return;
      atcButton.classList.add('processing');
    }
    function clearProcessing() {
      if (!atcButton) return;
      atcButton.classList.remove('processing');
    }

    function fallbackNativeSubmit() {
      try { form.submit(); } catch (e) {}
    }

    function handleSubmit(e) {
      e.preventDefault();
      e.stopPropagation();

      if (atcButton.classList.contains('processing')) return;

      setProcessing();

      // If Empire flyout class isn't global, we can't use it
      if (typeof window.AddToCartFlyout !== 'function') {
        warn('AddToCartFlyout is NOT global. Falling back to native submit.');
        clearProcessing();
        fallbackNativeSubmit();
        return;
      }

      // Empire flyout needs template + wrapper to render
      var flyoutDOM = ensureEmpireFlyoutDOM();
      log('Flyout prereqs', {
        hasAddToCartFlyout: true,
        wrapper: !!flyoutDOM.wrapper,
        template: !!flyoutDOM.template
      });

      if (!flyoutDOM.ok) {
        warn('Empire flyout markup missing on this page. No flyout can render here.');
        clearProcessing();
        fallbackNativeSubmit();
        return;
      }

      // Clean previous instance if we created one
      if (root._msoFlyout && typeof root._msoFlyout.unload === 'function') {
        try { root._msoFlyout.unload(); } catch (e) {}
      }

      var formDataArray = serializeFormArray(form);
      var optionsObj = {
        atcButton: atcButton,
        settings: {
          moneyFormat: getThemeMoneyFormat(),
          cartRedirection: getCartRedirectionSetting()
        }
      };

      try {
// Ensure we have ONE real wrapper in <body>
function ensureWrapper() {
  var existing = document.querySelector('.atc-popup-wrapper');
  if (existing && existing.parentElement === document.body) return existing;

  // If wrapper exists but not in body (PageFly/dom swaps), recreate it
  var wrapper = existing;
  if (!wrapper) {
    wrapper = document.createElement('div');
    wrapper.className = 'atc-popup-wrapper';
  }

  // Ensure overlay exists
  var overlay = wrapper.querySelector('.popup-cart-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'popup-cart-overlay';
    overlay.innerHTML = '&nbsp;';
    wrapper.appendChild(overlay);
  }

  document.body.appendChild(wrapper);
  return wrapper;
}

root._msoFlyout = new window.AddToCartFlyout(formDataArray, optionsObj, {
  onError: function (e2) {
    warn('Flyout onError', e2);
    clearProcessing();
  },
  onSuccess: function () {
    log('Flyout onSuccess');

    // --- FORCE MOUNT ---
    // Empire creates the real flyout element at: root._msoFlyout.flyOut
    // But on PageFly templates, their append sometimes fails.
    try {
      var wrapper = ensureWrapper();
      var overlay = wrapper.querySelector('.popup-cart-overlay');

      // If Empire instance has a flyOut node, move it to wrapper
      var flyOutNode = root._msoFlyout && root._msoFlyout.flyOut;

      // If it's not present, fall back to cloning the template ourselves
      if (!flyOutNode) {
        var template = document.querySelector('[data-templates] [data-atc-banner]');
        if (template) {
          flyOutNode = template.cloneNode(true);
        }
      }

      if (flyOutNode) {
        // Remove any existing visible flyout
        wrapper.querySelectorAll('[data-atc-banner]').forEach(function(n){ n.remove(); });

        // Force attributes so Empire CSS + transitions consider it "open"
        flyOutNode.setAttribute('data-animation-state', 'open');
        flyOutNode.style.display = 'block';

        // Show overlay + wrapper
        wrapper.style.display = 'block';
        overlay && (overlay.style.display = 'block');

        // Add body open class (Empire uses this for scroll lock / styling)
        document.body.classList.add('atc-banner-open');

        wrapper.appendChild(flyOutNode);

        // Close button wiring (since we forced mount)
        var closeBtn = flyOutNode.querySelector('[data-atc-banner-close]');
        if (closeBtn) {
          closeBtn.addEventListener('click', function() {
            wrapper.style.display = 'none';
            overlay && (overlay.style.display = 'none');
            document.body.classList.remove('atc-banner-open');
            flyOutNode.remove();
          }, { once: true });
        }

        // Click outside closes
        overlay && overlay.addEventListener('click', function() {
          wrapper.style.display = 'none';
          overlay.style.display = 'none';
          document.body.classList.remove('atc-banner-open');
          flyOutNode.remove();
        }, { once: true });
      } else {
        warn('No flyOut node found to mount.');
      }
    } catch (ex) {
      err('Force mount failed', ex);
    }

    clearProcessing();
  },
  onClose: function () {
    log('Flyout onClose');
    clearProcessing();
  }
});


      } catch (ex) {
        err('Failed to instantiate AddToCartFlyout', ex);
        clearProcessing();
        fallbackNativeSubmit();
      }
    }

    form.addEventListener('submit', handleSubmit);

    atcButton.addEventListener('click', function (e) {
      e.preventDefault();
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-mobile-sticky-offer]');
    log('Found sticky offer roots:', roots.length);
    roots.forEach(initOne);
  }

  // Run on normal pages
  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('load', initAll);

  // Run when Shopify sections re-render (theme editor / dynamic)
  document.addEventListener('shopify:section:load', initAll);

 
  



})();
